export const SAVE_SEARCH_DATA = "SAVE_SEARCH_DATA";
export const SAVE_SEARCH_RESULTS = "SAVE_SEARCH_RESULTS";
export const SAVE_FEATURED_LISTINGS = "SAVE_FEATURED_LISTINGS";
export const SAVE_PROPERTY_TYPES = "SAVE_PROPERTY_TYPES";
export const COM_SAVE_SEARCH_DATA = "COM_SAVE_SEARCH_DATA";
